import { AxiosInstance } from 'axios';

export function createSecurityApi(client: AxiosInstance) {
  return {
    async getSecurityCenter(queryString?: string) {
      const response = await client.get(`/owner/security-center${queryString || ''}`, {
        suppressAuthRedirect: true,
      } as any);
      return response.data;
    },
    async getSecurityAlerts() {
      const response = await client.get('/admin/security-alerts');
      return response.data;
    },
    async getSecurityAlertDetail(id: number) {
      const response = await client.get(`/owner/security-alerts/${id}`);
      return response.data;
    },
    async reviewSecurityAlert(id: number, data?: { status?: string; review_note?: string }) {
      const response = await client.patch(`/owner/security-alerts/${id}/review`, data || {});
      return response.data;
    },
    async revokeSecuritySession(id: number) {
      const response = await client.delete(`/owner/security-sessions/${id}`);
      return response.data;
    },
    async revokeAllUserSessions(userId: number) {
      const response = await client.delete(`/owner/users/${userId}/sessions`);
      return response.data;
    },
    async suspendUserFromSecurityCenter(userId: number) {
      const response = await client.post(`/owner/users/${userId}/suspend`);
      return response.data;
    },
    async unlockAccountFromSecurityCenter(userId: number) {
      const response = await client.post(`/owner/users/${userId}/unlock`);
      return response.data;
    },
    async forcePasswordResetFromSecurityCenter(userId: number) {
      const response = await client.post(`/owner/users/${userId}/force-password-reset`);
      return response.data;
    },
    async getAuditEvents(queryString?: string) {
      const response = await client.get(`/audit/events${queryString || ''}`);
      return response.data;
    },
    async getAuditEventDetail(eventId: string) {
      const response = await client.get(`/audit/events/${encodeURIComponent(eventId)}`);
      return response.data;
    },
  };
}

export type SecurityApi = ReturnType<typeof createSecurityApi>;
